import apiFetch from '../../../utils/apiFetch';
export async function commitRecklessAttack(characterId, input) {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/barbarian/reckless`, {
    method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(input),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Reckless Attack could not be saved. Retry the same attack.');
  return result;
}
export function readPendingBarbarianAttack(key) {
  try { const value=JSON.parse(sessionStorage.getItem(key));return value && typeof value.resolutionId==='string' ? value : null; } catch { return null; }
}
export function savePendingBarbarianAttack(key, value) {
  try { if(value)sessionStorage.setItem(key,JSON.stringify(value));else sessionStorage.removeItem(key); } catch { /* Current tab still retains dice if storage is unavailable. */ }
}

export async function claimBerserkerFrenzy(characterId, input) {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/barbarian/frenzy`, {
    method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(input),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Frenzy could not be confirmed. Retry the same attack.');
  return result;
}
